<template>
  <a>
    <a class="btnFunc">
      <i @click.stop="ZonaBoton(true)" class="icon-link-square color-11"></i>
    </a>
    <a class="btnFunc">
      <i @click.stop="ZonaBoton(false)" class="icon-clip color-11"></i>
    </a>
  </a>
</template>

<script>

import $ from "jquery";
import { mapMutations } from "vuex";

export default {
  name: "ZonaActiva",

  data: () => ({
    //
  }),
  methods: {
    AbrirZonaActiva(){
      this.$store.state.modalAsignarRecurso = true;
      this.$store.state.modal = true;
    },
    ZonaBoton(isTransparent){
      $('aside').css('cursor','crosshair');
      let zone
      this.$store.state.isModeActiveZone = true;
      this.$store.state.transparente = isTransparent;
      zone = 'zone'
      if(isTransparent){
         zone = 'zoneT'
        $('.moveable-control-box').css('opacity', '1')
      }
      this.setTypeResource(zone);
    },
    ...mapMutations(['setTypeResource'])
  },
  mounted: function () {
   
  }
};
</script>